
export default {
    auth : require('./auth.json'),
    recipient : require('./recipient.json'),
    company : require('./company.json'),
    campaign : require('./campaign.json'),
    report : require('./report.json'),
    leaderboard : require('./leaderboard.json')

}



// WEBPACK FOOTER //
// ./lang/en/index.js